import { useContext, useEffect, useMemo, useState } from 'react'
import {
    classApi,
  departments as departmentsApi,
  directionAPI,
  rolesOrder,
  usersAPI,
} from '@/api'
import { useAsync } from 'react-use'
import { useAddAlert } from '@/hooks/useAddAlert'
import {
  getArrayWithChildren,
  OpenItem,
} from '@pages/Admin/Surveys/Create/Access'
import Preloader from '@UI/Preloader'
import s from './index.module.css'
import { ModalSettingContext } from '../..'
import { compareOptionsByLabel } from '@/helpers/new/compareOptionsByLabel'
import { useApiSearch } from '@/hooks/useApiSearch'
import Select from '@UI/New/Select'

export const Customizable = () => {
    const addAlert = useAddAlert()
    const { state, setFieldInState } = useContext(ModalSettingContext);
    const rolesState = useAsync(rolesOrder.getList, [])
    const departmentsState = useAsync(departmentsApi.getAll, [])
    const rolesData = rolesState.value?.data || []
    const directionsState = useAsync(directionAPI.getAll, [])

    useEffect(() => {
        if (rolesState.error)
        addAlert({
            title: 'Ошибка',
            text: 'Ошибка при загрузке ролей доступа',
            type: 'error',
        })
    }, [rolesState.error])

    useEffect(() => {
        if (departmentsState.error)
        addAlert({
            title: 'Ошибка',
            text: 'Ошибка при загрузке отделов',
            type: 'error',
        })
    }, [departmentsState.error])

    useEffect(() => {
        if (directionsState.error)
            addAlert({
            title: 'Ошибка',
            text: 'Ошибка при загрузке направлений',
            type: 'error',
        })
    }, [directionsState.error])


    const [arrayValues, setArrayValues] = useState([[], [], []])
  
  
    const [selectedClasses, setSelectedClasses] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const {
            data: classes = [],
            loading: loadingClasses,
            searchQuery: searchQueryClasses,
            setSearchQuery: setSearchQueryClasses
        } = useApiSearch({
            apiMethod: classApi.getClassesAndFolders, //to correct (сделать чтобывозвращало все, без пагинации)
            responseKey: 'data',
            searchKey: 'filter[search]'
        });

    const fieldsClass = {
        tokenSeparators: [','],
        mode: "multiple",
        loading: loadingClasses,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: false,
        onChange: value => setSelectedClasses(value),
        options: classes.map(iterClass => ({label: iterClass.title, value: iterClass.id})),
        value: selectedClasses,
        placeholder: 'Выберите классы',
        onSearch: setSearchQueryClasses,
        notFoundContent: searchQueryClasses.length < 3 
            ? "Введите 3 или более символов" 
            : "Классы не найдены" 
    };

    const userParams = useMemo(() => {
        return (
            {
                'filter[role][eq]': `children`, //to correct не приходит если не выбраны ученики, надо сделать для всех
            }
        )
    }, []);
    
    const {
            data: users = [],
            loading: loadingUsers,
            searchQuery: searchQueryUsers,
            setSearchQuery: setSearchQueryUsers
        } = useApiSearch({
            apiMethod: usersAPI.getUsers,
            responseKey: 'data',
            searchKey: 'filter[search]',
            params: userParams
        });

   
    const fieldsUser = {
        tokenSeparators: [','],
        mode: "multiple",
        loading: loadingUsers,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: false,
        onChange: value => setSelectedUsers(value),
        options: users.map(user => ({label: user.name, value: user.id})),
        value: selectedUsers,
        placeholder: 'Выберите пользователей',
        onSearch: setSearchQueryUsers,
        notFoundContent: searchQueryUsers.length < 3 
            ? "Введите 3 или более символов" 
            : "Пользователи не найдены" 
    };
    
    useEffect(() => {
        const [roles, departments, directions] = arrayValues
    
        setFieldInState({field: 'customizableValue', value: {
            roles: roles.map(el => rolesData.find(role => role.id === el)?.role),
            departments,
            classes: selectedClasses,
            users: selectedUsers,
            directions
        }})

    }, [arrayValues, selectedClasses, selectedUsers])

    console.log(state.customizableValue)
  
    return (
        <div className={s.wrapper}>
        {
        (
            rolesState.loading ||
            departmentsState.loading ||
            directionsState.loading
        )
        ?
        (
            <Preloader />
        ) : (
            <div className={s.accessBlock}>
                <div className={s.openItemWrapper}>
                    <OpenItem
                        arrayNames={[
                        {
                            name: 'Роли',
                            children: getArrayWithChildren(rolesState.value?.data || []),
                        },
                        {
                            name: 'Отделы',
                            children: getArrayWithChildren(
                            departmentsState.value?.data || [],
                            ),
                        },
                        {
                            name: 'Учащиеся курсов',
                            children: getArrayWithChildren(
                                directionsState.value?.data?.data ?? [],
                            ),
                        },
                        ]}
                        arrayValues={arrayValues}
                        setArrayValues={setArrayValues}
                    />
                </div>
                <Select 
                    wrapperClassName={s.wrapperSelect} 
                    className={s.select} 
                    fields={fieldsClass} 
                />
                <Select 
                    wrapperClassName={s.wrapperSelect} 
                    className={s.select} 
                    fields={fieldsUser} 
                />
            </div>
        )}
        </div>
    )
}